var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21552_8387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6C7.74312 6 8.75 4.99312 8.75 3.75C8.75 2.50688 7.74312 1.5 6.5 1.5C5.25688 1.5 4.25 2.50688 4.25 3.75C4.25 4.99312 5.25688 6 6.5 6ZM6.5 7.125C4.99813 7.125 2 7.87875 2 9.375V10.5H11V9.375C11 7.87875 8.00187 7.125 6.5 7.125Z",
    fill: "#AAAAB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21552_8387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1309732a.svg";
export { ForwardRef as ReactComponent };